var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 4.75V12.25C13 15.25 12.25 16 9.25 16H4.75C1.75 16 1 15.25 1 12.25V4.75C1 1.75 1.75 1 4.75 1H9.25C12.25 1 13 1.75 13 4.75Z",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.5 3.625H5.5",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.9999 13.825C7.64193 13.825 8.1624 13.3045 8.1624 12.6625C8.1624 12.0205 7.64193 11.5 6.9999 11.5C6.35787 11.5 5.8374 12.0205 5.8374 12.6625C5.8374 13.3045 6.35787 13.825 6.9999 13.825Z",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceIcon);
export default __webpack_public_path__ + "static/media/device-icon.fab93071f8985c7d43664b708d42cf02.svg";
export { ForwardRef as ReactComponent };